import _ from "lodash";
import axios, { Cancel, CancelToken } from "axios";

import store from "../../redux/store";
import { actions as authActions } from "../modules/Auth/redux/actions";
// import Config from 'app/helpers/Config';
// import * as _redux from '../../redux';

class SpmApi {
  constructor() {
    const {
      auth: { authToken },
    } = store.getState();

    this.authToken = authToken;

    this.storeStateDidUpdate = this.storeStateDidUpdate.bind(this);

    // 註冊store update的通知
    store.subscribe(this.storeStateDidUpdate);
  }

  storeStateDidUpdate() {
    const { auth: { authToken } = {} } = store.getState();

    this.authToken = authToken;
  }

  getToken() {
    return this.authToken;
  }

  getHeaders() {
    const headers = {};
    if (!_.isEmpty(this.getToken())) {
      headers.Authorization = `Bearer ${this.getToken()}`;
    }
    return headers;
  }

  // common create function
  // 處理預設值與錯誤處理
  create() {
    // 測試模式，登入採用本地 Mock
    // 並且送出 API 時會預設加上 testMode = 'Y'
    // 略過 API 端的 Token 驗證
    // const isTestMode = Config.get('API_TEST_MODE') === true;

    //建構axios實體
    const instance = axios.create({
      timeout: 600000,
      withCredentials: false,
    });

    // if (isTestMode) {
    //   _redux.mockAxios(instance)
    // }

    // 預先處理 request
    instance.interceptors.request.use((config) => {
      const authToken = this.getToken();

      if (authToken) {
        config.headers = config.headers || {};
        config.headers.Authorization = `Bearer ${authToken}`;
      }

      return config;
    });

    // 預先處理 response
    instance.interceptors.response.use(
      (response) => {
        let precessedResponse = {
          ...response,
          axiosData: response.data,
          code: _.toString(_.get(response.data, "code", "100")),
          msg: _.get(response.data, "msg", "發生錯誤"),
          data: _.get(response.data, "data", {}),
        };

        if (
          [
            "application/pdf",
            "application/zip",
            "application/octet-stream",
          ].includes(response.headers?.["content-type"])
        ) {
          precessedResponse = {
            ...response,
            axiosData: response.data,
            code: response.data ? "200" : "100",
            msg: response.data ? "" : "發生錯誤",
            data: response.data,
          };
        }

        // == 有需要的人自己開關(先關掉) == //
        console.log(
          `SpmApi [${precessedResponse.config.method}] ${decodeURI(
            precessedResponse.request.responseURL
          )}`,
          precessedResponse
        );

        if (!precessedResponse.code.match(/^200/)) {
          // 錯誤處理，主要處理 token 過期
          const errorHandlers = {
            "999": () => {
              this.handleAuthDenied();
            },
          };

          let isHandled = false;
          _.each(errorHandlers, (handler, code) => {
            if (code === precessedResponse.code) {
              handler();
              isHandled = true;
            }
          });

          // 未處理完的錯誤往外拋讓外部處理
          if (!isHandled) {
            const error = new Error(precessedResponse.reason);

            error.response = precessedResponse;

            return Promise.reject(error);
          }
        }

        return precessedResponse;
      },
      error => {
        console.log(error.response)
        const errorCode = _.get(error, 'response.data.code')
        if(errorCode === '403'){
          _.set(error, 'response.data.msg', `Token已失效 `)
        }

        return Promise.reject(error)
      },
    );

    return instance;
  }

  // aliases functions
  get(url, params, args) {
    return this.send("get", url, params, null, args);
  }

  post(url, params, data, args) {
    return this.send("post", url, params, data, args);
  }

  put(url, params, data, args) {
    return this.send("put", url, params, data, args);
  }

  delete(url, params, data, args) {
    return this.send("delete", url, params, data, args);
  }

  // send 'get|post|delete' http request
  // return cancelToken
  send(method, url, params, data, args) {
    const instance = this.create();

    const config = {
      method,
      url,
      params,
      data,
      ...args,
    };

    config.cancelToken = new CancelToken(token => { config.cancel = token });

    return instance.request(config);
  }

  // 共用Request，只執行最後一道，但是callback都會被call到
  // 減少消耗
  requestInfos = [];

  sharedGet(url, query, callback) {

    const requestName = url.replace(/(\.)/g, '__')

    let requestInfo = _.get(this.requestInfos, requestName)
    const cancelToken = _.get(requestInfo, `cancelToken`)
    if (cancelToken) {
      cancelToken(`sharedGet ${requestName} By Last Query`);
    }

    if (!requestInfo) {
      requestInfo = {
        name: requestName,
        cancelToken: null,
        callbacks: []
      }
      this.requestInfos[requestName] = requestInfo
    }

    requestInfo.callbacks.push(callback);
    const callbackWapper = (state, res) => {
      if (res.error instanceof Cancel) return

      const callbacks = _.get(this.requestInfos, `${requestName}.callbacks`, [])

      _.forEach(callbacks, cb => cb(state, res))

      delete this.requestInfos[requestName]
    }
    requestInfo.cancelToken = this.send('get', url, query, null, callbackWapper)
  }

  // 未登入
  // access token 過期
  handleAuthDenied = _.debounce(() => {
    store.dispatch(authActions.logout("登入資訊過期，請從重新登入"));
  }, 100);

  // 共用方法
  url = (url, params) => {
    console.log("OmsApi url", url, params);
    const processedUrl = new URL(url);
    _.forEach(params, (key, value) => {
      processedUrl.searchParams.set(key, value);
    });
    window.ll = processedUrl;
    return processedUrl.href;
  };
}

export default new SpmApi();
